import type { SpaceBackground } from '../types/spaces';

/**
 * Default background for newly created spaces.
 * Must match `DEFAULT_SPACE_BACKGROUND_PRESET` in `backend/config/constants.py`
 * and the `bgN` preset classes (App.scss `--bg-N`, GUILayout).
 *
 * Product name for preset 1: "River Valley" (Space → Background in the app).
 */
export const DEFAULT_NEW_SPACE_BACKGROUND_PRESET_ID = 'bg1' as const;

/** Human-readable name for the default preset (Space → Background swatch tooltip). */
export const DEFAULT_NEW_SPACE_BACKGROUND_PRESET_LABEL = 'River Valley';

export const DEFAULT_NEW_SPACE_BACKGROUND: SpaceBackground = {
  type: 'preset',
  value: DEFAULT_NEW_SPACE_BACKGROUND_PRESET_ID,
};
